export default __webpack_public_path__ + "static/media/cny-flower-2.c7b9acd3.webp";